"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "subtitle2ClassNames", {
    enumerable: true,
    get: function() {
        return _useSubtitle2Stylesstyles.subtitle2ClassNames;
    }
});
const _export_star = require("@swc/helpers/_/_export_star");
_export_star._(require("./Subtitle2"), exports);
const _useSubtitle2Stylesstyles = require("./useSubtitle2Styles.styles");
